module.exports = __webpack_public_path__ + "static/media/csrd_report4.5dfd3236.svg";